<template>
  <div class="tabs-section" v-loading="loading">
    <div class="tabs-header">
      <el-tabs v-model="currentActiveTab" @tab-click="tabClickHandle">
        <el-tab-pane label="推进中" name="pushing"></el-tab-pane>
        <el-tab-pane label="长期维护" name="maintain"></el-tab-pane>
        <el-tab-pane label="已签约" name="signed"></el-tab-pane>
      </el-tabs>
      <el-button v-if="showAddClueBtn" type="primary" icon="el-icon-plus" size="small" class="add-btn" @click="addClueHandle">新增线索</el-button>
    </div>

    <!-- 筛选区 -->
    <div class="filter-bar">
      <div class="filter-tags" v-if="currentActiveTab === 'pushing'">
        <el-tag
          v-for="tag in filterTags"
          :key="tag.value"
          :class="{ active: subActiveTab === tag.value }"
          @click="subTabChangeHandle(tag.value)"
          size="small"
        >{{ tag.label }}({{ tag.count }})</el-tag>
      </div>
      <div class="filter-count" v-else>
        合计{{ pageInfo.total }}条线索
      </div>
      <div class="filter-options">
        <div v-if="['pushing', 'maintain'].includes(currentActiveTab)">
          <el-checkbox :value="filterForm.overdue" @input="formChangeHandle('overdue', $event)">超期预警</el-checkbox>
        </div>
        <el-input
          :value="filterForm.searchKeyword"
          @input="formChangeHandle('searchKeyword', $event)"
          placeholder="搜索姓名、毕业院校"
          size="small"
          class="search-input"
          suffix-icon="el-icon-search"
        ></el-input>
      </div>
    </div>

    <!-- 表格 -->
    <CustomFilterableTable
      v-model="headerFilters"
      :tableData="clueList"
      :column="currentColumns"
      border
      class="lead-table"
      :header-cell-style="headerCellStyle"
      max-height="350"
      filter-mode="backend"
      :total="pageInfo.total"
      @backend-filter-change="handleBackendFilterChange"
    >
      <template slot="nameCell" slot-scope="{ row }">
        <el-tag
          v-if="row.doctorName"
          type="info"
          effect="plain"
          size="small"
          @click="$emit('nameClick', row)"
        >{{ row.doctorName }}</el-tag>
      </template>
      <!-- 星级 -->
      <template slot="starCell" slot-scope="{ row }">
        <CustomStarText :saleStar="row.saleStar" :avgStar="row.avgStar" />
      </template>
      <!-- 月销售额 -->
      <template slot="monthSaleCell" slot-scope="{ row }">
        <span>{{ row.monthSale }}万</span>
      </template>
      <!-- 阶段 -->
      <template slot="stageCell" slot-scope="{ row }">
        <span>{{ stageInfo[row.currentStepCode] }}</span>
      </template>
      <!-- 截止日期 -->
      <template slot="taskEndDateCell" slot-scope="{ row }">
        <span v-if="row.taskEndDate">{{ row.taskEndDate }}</span>
        <span v-if="row.taskEndDate && row.endTimeDay < 15" class="visit-tag overdue">
          <i class="el-icon-time"></i>&nbsp;{{ row.endTimeDay > 0 ? (row.endTimeDay + '天') : (row.endTimeHour + ':' + row.endTimeMinute) }}
        </span>
      </template>
      <!-- 拜访状态 -->
      <template slot="visitCell" slot-scope="{ row }">
        <span v-if="row.showNoVisitTag" class="visit-tag unvisited">{{ row.noVisitDays }}天未拜访</span>
        <span v-else class="visit-tag normal">正常拜访</span>
      </template>
      <template slot="followerTagCell" slot-scope="{ row }">
        <el-tag
          v-if="row.followerWorkName"
          type="info"
          effect="plain"
          size="small"
          style="cursor: pointer;"
          @click="$emit('followerClick', row)"
        >{{ row.followerWorkName }}</el-tag>
      </template>
      <template slot="maintainReasonCell" slot-scope="{ row }">
        <span class="ellipsis-text" :title="row.maintainReason">{{ row.maintainReason }}</span>
      </template>
    </CustomFilterableTable>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        :current-page.sync="syncCurrentPage"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { debounce } from '@/utils/validateBase'

const stageInfo = {
  'S020': '信息采集',
  'S030': '长期维护',
  'S040': '邀约参观',
  'S050': '领导协访',
  'S060': '推进签约'
}
export default {
  name: 'ClueListInfo',
  // 表头筛选共享配置
  filterConfigs: {
    star: {
      type: 'checkbox-group',
      groups: [
        { 
          key: 'saleStar',
          title: '销售星级',
          options: [
            { label: '五星', value: '5' },
            { label: '四星', value: '4' },
            { label: '三星', value: '3' },
            { label: '二星', value: '2' },
            { label: '一星', value: '1' }
          ]
        },
        {
          key: 'avgStar',
          title: '次均星级',
          options: [
            { label: '五星', value: '5' },
            { label: '四星', value: '4' },
            { label: '三星', value: '3' },
            { label: '二星', value: '2' },
            { label: '一星', value: '1' }
          ]
        }
      ]
    },
    monthSale: { type: 'range', unit: '万' },
    avgVisitNum: { type: 'range' },
    maintainDate: { type: 'daterange' },
    taskEndDate: { type: 'daterange' },
    visitStatus: {
      type: 'checkbox',
      options: [
        { label: '正常拜访', value: 'normal' },
        { label: '超期未拜访', value: 'overdue' }
      ]
    },
    groupTag: {
      type: 'checkbox',
      options: [] // 动态加载，初始为空数组
    }
  },
  props: {
    groupInfoId: {
      type: [String, Number],
      default: ''
    },
    workNumber: {
      type: [String, Number],
      default: ''
    },
    // 是否显示团队列
    showTeamCol: {
      type: Boolean,
      default: true
    },
    // 是否显示跟进人列
    showFollowerCol: {
      type: Boolean,
      default: true
    },
    // 是否显示新增线索按钮
    showAddClueBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeTab: 'pushing',
      subActiveTab: 'all',
      filterTags: [
        { label: '全部', stepCode: '', value: 'all', count: 0 },
        { label: '推进签约', stepCode: 'S060', value: 'sign', count: 0 },
        { label: '领导协访', stepCode: 'S050', value: 'visit', count: 0 },
        { label: '邀约参观', stepCode: 'S040', value: 'tour', count: 0 },
        { label: '信息采集', stepCode: 'S020', value: 'info', count: 0 }
      ],
      filterForm: {
        overdue: false,
        searchKeyword: ''
      },
      pageInfo: {
        total: 0,
        pageSize: 20,
        pageNum: 1
      },
      headerFilters: {},
      // 推进中列配置
      pushingColumns: [
        { prop: 'doctorName', label: '医生', minWidth: '100', align: 'left', slotName: 'nameCell' },
        { prop: 'star', label: '星级', minWidth: '100', align: 'left', slotName: 'starCell', filterConfig: this.$options.filterConfigs.star },
        { prop: 'monthSale', label: '月销售额', minWidth: '100', align: 'left', slotName: 'monthSaleCell', filterConfig: this.$options.filterConfigs.monthSale },
        { prop: 'avgVisitNum', label: '次均门诊量', minWidth: '100', align: 'right', filterConfig: this.$options.filterConfigs.avgVisitNum },
        { prop: 'stage', label: '阶段', minWidth: '100', align: 'left', slotName: 'stageCell' },
        { prop: 'taskEndDate', label: '截止日期', minWidth: '160', align: 'left', slotName: 'taskEndDateCell', filterConfig: this.$options.filterConfigs.taskEndDate },
        { prop: 'visitStatus', label: '拜访状态', minWidth: '100', align: 'left', slotName: 'visitCell', filterConfig: this.$options.filterConfigs.visitStatus },
        { prop: 'groupName', label: '团队', minWidth: '100', align: 'left', filterConfig: this.$options.filterConfigs.groupTag },
        { prop: 'followerWorkName', label: '跟进人', minWidth: '100', align: 'left', slotName: 'followerTagCell' }
      ],
      // 长期维护列配置
      maintainColumns: [
        { prop: 'doctorName', label: '医生', minWidth: '100', align: 'left', slotName: 'nameCell' },
        { prop: 'star', label: '星级', minWidth: '100', align: 'left', slotName: 'starCell', filterConfig: this.$options.filterConfigs.star },
        { prop: 'monthSale', label: '月销售额', minWidth: '110', align: 'left', filterConfig: this.$options.filterConfigs.monthSale },
        { prop: 'avgVisitNum', label: '次均门诊量', minWidth: '110', align: 'right', filterConfig: this.$options.filterConfigs.avgVisitNum },
        { prop: 'maintainDate', label: '转长期维护时间', minWidth: '180', align: 'left', filterConfig: this.$options.filterConfigs.maintainDate },
        { prop: 'maintainReason', label: '转长期维护原因', minWidth: '200', align: 'left', slotName: 'maintainReasonCell' },
        { prop: 'taskEndDate', label: '截止日期', minWidth: '180', align: 'left', slotName: 'taskEndDateCell', filterConfig: this.$options.filterConfigs.taskEndDate },
        { prop: 'visitStatus', label: '拜访状态', minWidth: '100', align: 'left', slotName: 'visitCell', filterConfig: this.$options.filterConfigs.visitStatus },
        { prop: 'groupName', label: '团队', minWidth: '100', align: 'left', filterConfig: this.$options.filterConfigs.groupTag },
        { prop: 'followerWorkName', label: '跟进人', minWidth: '100', align: 'left', slotName: 'followerTagCell' }
      ],
      // 已签约列配置
      signedColumns: [
        { prop: 'doctorName', label: '医生', minWidth: '100', align: 'left', slotName: 'nameCell' },
        { prop: 'star', label: '星级', minWidth: '100', align: 'left', slotName: 'starCell', filterConfig: this.$options.filterConfigs.star },
        { prop: 'monthSale', label: '月销售额', minWidth: '100', align: 'left', filterConfig: this.$options.filterConfigs.monthSale },
        { prop: 'avgVisitNum', label: '次均门诊量', minWidth: '110', align: 'right', filterConfig: this.$options.filterConfigs.avgVisitNum },
        { prop: 'auditerNameText', label: '审批人', minWidth: '100', align: 'left' },
        { prop: 'signDate', label: '签约日期', minWidth: '120', align: 'left' },
        { prop: 'groupName', label: '团队', minWidth: '100', align: 'left', filterConfig: this.$options.filterConfigs.groupTag },
        { prop: 'followerWorkName', label: '跟进人', minWidth: '100', align: 'left', slotName: 'followerTagCell' }
      ],
      clueList: [],
      loading: false,
      stageInfo
    }
  },
  computed: {
    // 当前 tab 对应的表格列配置
    currentColumns() {
      const columnsMap = {
        pushing: this.pushingColumns,
        maintain: this.maintainColumns,
        signed: this.signedColumns
      }
      let columns = columnsMap[this.activeTab] || this.pushingColumns
      columns = this.showTeamCol ? columns : columns.filter(column => column.prop !== 'groupName')
      columns = this.showFollowerCol ? columns : columns.filter(column => column.prop !== 'followerWorkName')
      return columns
    },
    syncCurrentPage: {
      get() {
        return this.pageInfo.pageNum
      },
      set(val) {
        this.pageInfo.pageNum = val
      }
    },
    currentActiveTab: {
      get() {
        return this.activeTab
      },
      set(val) {
        this.activeTab = val
      }
    }
  },
  methods: {
    headerCellStyle() {
      return { background: '#F7F8F9', color: '#667182', fontWeight: 500 }
    },

    // 获取团队列表（用于团队筛选列配置）
    async getTeamList() {
      try {
        const res = await request.get('/cluepool/pc/admin/group/list', {}, '')
        if (res.code === 200) {
          this.$options.filterConfigs.groupTag.options = (res.data || []).map(item => ({
            label: item.groupName || '',
            value: item.groupInfoId || ''
          }))
        } else {
          this.$options.filterConfigs.groupTag.options = []
        }
      } catch (error) {
        console.error('获取团队列表请求失败:', error)
        this.$options.filterConfigs.groupTag.options = []
      }
    },

    // 切换线索列表 tab
    tabClickHandle() {
      this.pageInfo.pageNum = 1
      if (this.activeTab === 'pushing') {
        this.getFollowingClueCount()
      }
      this.headerFilters = {}
      this.getClueList()
    },
    subTabChangeHandle(value) {
      this.subActiveTab = value
      this.getClueList()
    },
    formChangeHandle(key, value) {
      this.$set(this.filterForm, key, value)
      this.getClueList()
    },

    // 获取跟进中的线索统计
    async getFollowingClueCount() {
      const params = {
        ...this.groupInfoId && {
          groupInfoId: this.groupInfoId || ''
        },
        ...this.workNumber && {
          workNumber: this.workNumber || ''
        }
      }
      try {
        const res = await request.post('/cluepool/pc/clue/statistic', params, '')
        if (res.code === 200) {
          const data = res.data || {}
          let total = 0
          for (const key in data) {
            if (['S020', 'S040', 'S050', 'S060'].includes(key)) {
              total += Number(data[key])
            }
          }
          this.filterTags = this.filterTags.map(item => {
            if (item.stepCode) {
              return { ...item, count: data[item.stepCode] || 0 }
            } else {
              return { ...item, count: total || 0 }
            }
          })
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取线索统计数据请求失败', error)
      }
    },

    // 获取线索列表
    getClueList: debounce(async function () {
      const { activeTab, subActiveTab, filterForm, headerFilters } = this
      const { overdue, searchKeyword } = filterForm

      let url = ''
      let params = {
        ...searchKeyword && { queryStr: searchKeyword },
        ...this.groupInfoId && {
          groupInfoId: this.groupInfoId || ''
        },
        ...this.workNumber && {
          workNumber: this.workNumber || ''
        },
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      }

      // 将表头筛选条件转换为后端可识别的格式
      if (headerFilters && Object.keys(headerFilters).length > 0) {
        Object.keys(headerFilters).forEach(key => {
          const value = headerFilters[key]
          switch (key) {
            case 'star':
              if (value.saleStar && value.saleStar.length > 0) params['saleStarList'] = value.saleStar
              if (value.avgStar && value.avgStar.length > 0) params['avgStarList'] = value.avgStar
              break
            case 'monthSale':
              if (value.max) params['monthSaleMax'] = value.max || ''
              if (value.min) params['monthSaleMin'] = value.min || ''
              break
            case 'avgVisitNum':
              if (value.max) params['avgVisitNumMax'] = value.max || ''
              if (value.min) params['avgVisitNumMin'] = value.min || ''
              break
            case 'taskEndDate':
              if (value && value.length > 0) {
                params['taskEndTimeBegin'] = value[0] || ''
                params['taskEndTimeEnd'] = value[1] || ''
              }
              break
            case 'visitStatus':
              if (value && value.length > 0) {
                if (value.includes('overdue') && value.includes('normal')) {
                  // 选择了超期和正常,不做任何处理
                } else if (value.includes('overdue')) {
                  params['showNoVisitTag'] = true
                } else if (value.includes('normal')) {
                  params['showNoVisitTag'] = false
                }
              }
              break
            case 'groupName':
              if (value && value.length > 0) params['groupInfoIdList'] = value
              break
            default:
              break
          }
        })
      }

      switch (activeTab) {
        case 'pushing':
          url = '/cluepool/pc/clue/inProgressList'
          params = {
            ...params,
            sortType: 1,
            currentStepCodeList: subActiveTab === 'all' ? ['S060', 'S050', 'S040', 'S020'] : [(this.filterTags.find(item => item.value === subActiveTab) || {}).stepCode || ''],
            ...overdue && {
              showOverWarning: overdue
            }
          }
          break
        case 'maintain':
          url = '/cluepool/pc/clue/maintainList'
          params = { ...params, sortType: 1, showOverWarning: overdue || false }
          break
        case 'signed':
          url = '/cluepool/pc/clue/signedList'
          params = { ...params, queryAll: false }
          break
      }
      try {
        this.loading = true
        const res = await request.post(url, params, '')
        if (res.code === 200) {
          this.pageInfo.total = res.data.totalElements || 0
          this.clueList = (res.data.data || []).map(item => {
            const now = +new Date()
            const taskEndTime = item.taskEndTime ? +new Date(item.taskEndTime) : now
            const taskEndDate = new Date(taskEndTime).Format('yyyy-MM-dd')
            const endTimeDay = Math.floor((Math.max(0, taskEndTime - now)) / (1000 * 60 * 60 * 24))
            const endTimeHour = (Math.floor((Math.max(0, taskEndTime - now)) / (1000 * 60 * 60)) % 24).toString().padStart(2, '0')
            const endTimeMinute = (Math.floor((Math.max(0, taskEndTime - now)) / (1000 * 60)) % 60).toString().padStart(2, '0')
            return {
              ...item,
              taskInfos: item.taskInfos || [],
              taskEndDate: item.taskEndTime ? taskEndDate : '',
              maintainDate: item.maintainTime ? new Date(item.maintainTime).Format('yyyy-MM-dd') : '',
              signDate: item.signTime ? new Date(item.signTime).Format('yyyy-MM-dd') : '',
              endTimeDay: item.taskEndTime ? endTimeDay : '',
              endTimeHour: item.taskEndTime ? endTimeHour : '',
              endTimeMinute: item.taskEndTime ? endTimeMinute : '',
              auditerNameText: item.auditerName && item.auditerName.length > 0 ? item.auditerName.join(',') : ''
            }
          })
        } else {
          this.clueList = []
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取线索列表请求失败', error)
      } finally {
        this.loading = false
      }
    }, 300),

    // 表头筛选变化处理（后端过滤模式）
    handleBackendFilterChange({ prop, value, all }) {
      this.headerFilters = all || {}
      this.pageInfo.pageNum = 1
      this.getClueList()
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page
      this.getClueList()
    },
    addClueHandle() {
      this.$emit('addClue')
    }
  },
  mounted() {
    if (this.showTeamCol) {
      this.getTeamList()
    }
    this.getFollowingClueCount()
    this.getClueList()
  },
  components: {
    CustomFilterableTable: () => import('@/views/DoctorVisitLTC/components/customFilterableTable/CustomFilterableTable.vue'),
    CustomStarText: () => import('@/views/DoctorVisitLTC/components/customStarText/CustomStarText.vue')
  }
}
</script>

<style scoped lang="less">
.tabs-section {
  background: #fff;
  border-radius: 4px;
  padding: 20px 24px;

  .tabs-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    /deep/.el-tabs {
      flex: 1;
      border: none;
    }

    /deep/.el-tabs__header {
      margin-bottom: 0;
    }

    /deep/.el-tabs__nav-wrap::after {
      height: 0;
      background-color: transparent;
    }

    /deep/.el-tabs__item {
      font-size: 15px;
      font-weight: 500;
      color: #667182;

      &.is-active {
        color: #1F2329;
        font-weight: 600;
      }
    }

    /deep/.el-tabs__active-bar {
      background-color: #1890FF;
    }

    .add-btn {
      background-color: transparent;
      border-color: transparent;
      color: #1890FF;

      &:hover {
        color: #40A9FF;
      }

      /deep/ i {
        color: #1890FF;
      }
    }
  }

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 12px;

    .filter-tags {
      display: flex;

      /deep/.el-tag {
        cursor: pointer;
        height: 28px;
        line-height: 26px;
        padding: 0 12px;
        border-radius: 0px;
        font-size: 13px;
        background-color: #FFF;
        border-color: #E0E0E0;
        color: #667182;

        &:not(:first-child) {
          border-left: none;
        }

        &:first-child {
          border-radius: 4px 0 0 4px;
        }

        &:last-child {
          border-radius: 0 4px 4px 0;
        }

        &.active {
          background-color: #1890FF;
          border-color: #1890FF;
          color: #fff;
        }
      }
    }

    .filter-count {
      font-size: 14px;
    }

    .filter-options {
      display: flex;
      align-items: center;
      gap: 12px;

      /deep/.el-checkbox {
        margin-right: 6px;
      }

      /deep/.el-checkbox__label {
        font-size: 13px;
        color: #667182;
      }

      .search-date {
        width: 140px;
      }

      .star-select {
        width: 120px;
      }

      .search-input {
        width: 180px;
      }
    }
  }

  .lead-table {
    /deep/ .el-table {
      font-size: 13px;
      color: #1F2329;
      border-color: #EBEAEE;

      &::before,
      &::after {
        background-color: #EBEAEE;
      }

      th {
        padding: 0 !important;
        height: 40px;
      }

      td {
        padding: 0 !important;
        height: 44px;
      }

      .cell {
        line-height: 20px;
      }

      .header-cell-medium-section {
        padding: 0 !important;
        line-height: 20px !important;
      }

      .cell-medium-section {
        padding: 0 !important;
      }
    }

    /deep/ .el-tag--plain.el-tag--info {
      background-color: #F7F8F9;
      border-color: #EBEAEE;
      color: #667182;
      height: 24px;
      line-height: 22px;
      padding: 0 10px;
      border-radius: 12px;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        border-color: #1890FF;
        color: #1890FF;
      }
    }

    .visit-tag {
      display: inline-block;
      padding: 2px 8px;
      border-radius: 2px;
      font-size: 12px;

      &.normal {
        background-color: #E2F8E0;
        color: #29C01B;
      }

      &.overdue {
        margin-left: 4px;
        color: #F54A45;
      }

      &.unvisited {
        background-color: #FFF0E1;
        color: #FE8F1F;
      }
    }

    .ellipsis-text {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    }
  }

  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}

</style>
